import { type FC, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { env } from "~/env";

const METRICA_ID = env.VITE_YANDEX_METRICA_ID ?? "";
const INIT_SCRIPT_ID = "ym-init";

const YandexMetrica: FC = () => {
    const location = useLocation();

    useEffect(() => {
        if (!METRICA_ID) return;
        if (document.getElementById(INIT_SCRIPT_ID)) return;

        const script = document.createElement("script");
        script.id = INIT_SCRIPT_ID;
        script.innerHTML = `(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
                m[i].l=1*new Date();
                for(var j=0;j<document.scripts.length;j++){if(document.scripts[j].src===r){return;}}
                k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
                })(window,document,"script","https://mc.yandex.ru/metrika/tag.js","ym");
                ym(${METRICA_ID},"init",{clickmap:true,trackLinks:true,accurateTrackBounce:true,webvisor:true});
                window.__sntz_metrica_id=${METRICA_ID};`;
        document.head.appendChild(script);

        return () => {
            script.remove();
        };
    }, []);

    useEffect(() => {
        if (!METRICA_ID) return;
        if (typeof window === "undefined" || !("ym" in window)) return;
        const ymFn = window.ym as (id: string, action: string, url: string) => void;
        ymFn(METRICA_ID, "hit", location.pathname + location.search);
    }, [location.pathname, location.search]);

    if (!METRICA_ID) return null;

    return (
        <noscript>
            <div>
                <img
                    src={`https://mc.yandex.ru/watch/${METRICA_ID}`}
                    style={{ position: "absolute", left: "-9999px" }}
                    alt=""
                />
            </div>
        </noscript>
    );
};

export default YandexMetrica;
